exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.panel .ivu-table {\n    font-size: 12px;\n}\n.ivu-table {\n    font-size: 12px;\n}\n", "", {"version":3,"sources":["E:/eview/efview/src/components/form/ocmformdetail.vue"],"names":[],"mappings":";AACA;IACI,gBAAgB;CACnB;AACD;IACI,gBAAgB;CACnB","file":"ocmformdetail.vue","sourcesContent":["\n.panel .ivu-table {\n    font-size: 12px;\n}\n.ivu-table {\n    font-size: 12px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/form/ocmformdetail.vue
// module id = 955
// module chunks = 0